import { get } from "lodash-es"

interface Payload {
  websiteId: string
}

export default function defaultClassWebsiteContext(payload: Payload, models) {
  // We use get as some of these values might be null/undefined and we want to not break
  let websiteSlug = get(models, "classWebsite.attributes.slug")

  return {
    planbookTitle: get(models, "planbook.attributes.title"),
    websiteId: get(payload, "websiteId"),
    websiteURL: websiteSlug ? `www.commonplanner.com/sites/${websiteSlug}` : null,
  }
}
